import React from "react"

import { getThemeColor } from "./utils"

import Link from "@components/elements/Link"
import ArrowIcon from "@components/elements/V2/Icons/ArrowIcon"
import Typography from "@components/elements/V2/Typography"

type PriceCellProps = {
  price: number
  iconLink?: string
  theme: "light" | "dark"
}

const SimplePriceFromStoryblokSlug = ({
  price,
  iconLink,
  theme,
}: PriceCellProps) => {
  return (
    <div className="flex items-center gap-8">
      <Typography
        font="grotesk"
        weight="medium"
        color={getThemeColor(theme)}
        size="body-lg"
        text={"R" + price}
        className="text-start"
      />

      {iconLink && (
        <Link link={iconLink}>
          <ArrowIcon
            width="18"
            height="18"
            animateOnHover={false}
            className="pb-1 text-blue"
          />
        </Link>
      )}
    </div>
  )
}

export default SimplePriceFromStoryblokSlug
